import axios from "./axios";

export type TaskRequestStatus =
  | "PENDING"
  | "ACCEPTED"
  | "COMPLETED"
  | "REJECTED"
  | "ARCHIVE";

export interface TaskRequest {
  id: number;
  task_type: TaskType;
  description: string;
  created_at: string;
  received_at: string;
  status: TaskRequestStatus;
  created_by: {
    id: number;
    name: string;
  };
  micro_area: {
    id: number;
    initials: string;
    full_initials: string;
    area_id: number;
    area_name: string;
    farm_id: number;
    farm_name: string;
    coords: { latitude: number; longitude: number }[];
  };
  converted_task_id?: number;
  converted_at?: string;
  rejection_reason?: string;
}

export interface TaskRequestPage {
  content: TaskRequest[];
  totalPages: number;
}

export interface TaskRequestFilters {
  page: number;
  size: number;
  status?: TaskRequestStatus;
  taskType?: TaskType;
}

export const TASK_REQUEST_UPDATED_EVENT = "taskRequestUpdated";
export const TASK_REQUEST_REOPEN_EVENT = "taskRequestReopen";

function list(filters: TaskRequestFilters): Promise<TaskRequestPage> {
  return axios
    .get<TaskRequestPage>("/task-requests", {
      params: {
        page: filters.page,
        size: filters.size,
        status: filters.status,
        task_type: filters.taskType,
      },
    })
    .then(({ data }) => data);
}

function getById(id: number): Promise<TaskRequest> {
  return axios.get<TaskRequest>(`/task-requests/${id}`).then(({ data }) => data);
}

function getPendingCount(): Promise<number> {
  return axios
    .get<{ quantity: number }>("/task-requests/pending/count")
    .then(({ data }) => data.quantity || 0);
}

function reject(id: number, reason?: string): Promise<void> {
  return axios
    .patch(`/task-requests/${id}/reject`, { reason: reason || undefined })
    .then(() => undefined);
}

function notifyUpdated() {
  window.dispatchEvent(new CustomEvent(TASK_REQUEST_UPDATED_EVENT));
}

function notifyReopen(id: number) {
  window.dispatchEvent(
    new CustomEvent<number>(TASK_REQUEST_REOPEN_EVENT, { detail: id }),
  );
}

export const taskRequestService = {
  list,
  getById,
  getPendingCount,
  reject,
  notifyUpdated,
  notifyReopen,
};
